// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3igGj","colBig":"styles_colBig__31nes","colSmall":"styles_colSmall__1l1Kf"};